export default "__VITE_ASSET__BcXNvr1n__"